// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"a7df0153","283":"abd7b637","996":"fa9562ed"}[chunkId] + ".chunk.js";
};